export default function reducer (state = {
  activation: {}
}, action) {
  switch (action.type) {
    case 'SET_ACTIVATION':
      return {
        ...state,
        activation: action.payload
      }
    default: {
      return {
        ...state
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/activationReducer.js